import React from 'react';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from "react-localize-redux";
import { chartActions } from '../../store/charts/chartsStore';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Range } from 'rc-slider';


const F_ACTIVITY = {
    active: "active",
    inactive: "inactive"
};

class ChartTimeline extends React.Component {
    constructor(props) {
        super(props);
        this.state = { sliderVal: 1900, timelineEnabled: false };
    }

    componentDidUpdate() {
        if (this.props.bottomWindow.timeline.isShowed && this.props.bottomWindow.timeline.data) {
            this.correctHeights();
            if (this.state.timelineEnabled)
                this.moveTimeline(this.state.sliderVal);
        }
    }

    render() {
        return (
            <div>
                <table id="timelineTable" style={{ marginBottom: '5px', marginTop: '0px' }}>
                    <thead>
                        <tr style={{ height: '45px' }}>
                            <th id="timelineHeader" colSpan="2" style={{ paddingBottom: '5px', width: '480px', minWidth: '480px' }}>
                                {this.renderFilterInput()}
                            </th>
                            <th id="timelineContent" style={{ paddingLeft: '20px', width: '100%', minWidth: '250px' }}>
                                <div id="timelineSlider" className="slider" style={{ paddingTop: '5px' }}>
                                    {this.props.bottomWindow.timeline.data ?
                                        <Range
                                            onChange={(value) => this.sliderChange(value)}
                                            marks={this.props.bottomWindow.timeline.data.marks}
                                            defaultValue={[this.props.bottomWindow.timeline.data.minYear]}
                                            value={[this.state.sliderVal]}
                                            min={this.props.bottomWindow.timeline.data.minYear}
                                            max={this.props.bottomWindow.timeline.data.maxYear}
                                            allowCross={false}
                                            step={1 / 12}
                                            disabled={!this.state.timelineEnabled}
                                        /> : ''}
                                </div>
                                <div id="verticalLine"></div>
                            </th>
                        </tr>
                    </thead>
                    {this.props.bottomWindow.timeline.data ?
                        <tbody id="timeline-body">
                            {this.props.bottomWindow.timeline.data.relations.map((r, i) =>
                                <tr key={i}>
                                    <td style={{ minWidth: '240px', maxWidth: '240px' }}>{r.parentName}</td>
                                    <td style={{ minWidth: '240px', maxWidth: '240px' }}>{r.childName}</td>
                                    <td className="hasTooltip floatingGraphRelation" style={{ width: '100%' }}>
                                        <div className={`${r.linkClass} left-overflow-text`} ml={r.startOffset} w={r.finalWidth} style={{ marginLeft: `${r.startOffset}%`, width: `${r.finalWidth}%`, height: '100%', display: 'inlineBlock' }}
                                            onMouseMove={(e) => this.moveToolTip(e)} onMouseOut={(e) => this.hideToolTip(e)}>
                                            <bdi>{r.divText}</bdi>
                                            <div className="flowchart-tooltip" style={{ zIndex: 10 }}>
                                                <div className="row">
                                                    <div className="col-md-12">{r.Name}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12"><b><Translate id="Charts.From" />:</b> {r.dateFrom}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12"><b><Translate id="Charts.To" />:</b> {r.dateTo}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td colSpan={2} style={{ minWidth: '480px' }}>&nbsp;</td>
                                <td style={{ width: '100%' }}>
                                    <span style={{ paddingLeft: '50px' }}>
                                        <i className="currentRelation colorBox"></i>
                                        <label className="timeline-legend-label"><Translate id="Charts.ActualRelations" /></label>
                                    </span>
                                    <span style={{ paddingLeft: '100px' }}>
                                        <i className="historicalRelation colorBox"></i>
                                        <label className="timeline-legend-label"><Translate id="Charts.HistoricalRelations" /></label>
                                    </span>
                                </td>
                            </tr>
                        </tbody> : <tbody />}
                </table>
            </div>
        );
    }

    moveToolTip = (e) => {
        var x = (e.clientX + 5);
        var y = (e.clientY + 5);

        var tooltip = e.target.parentElement.getElementsByClassName('flowchart-tooltip')[0];
        if (tooltip) {
            tooltip.style.display = 'block';
            if (window.innerWidth - 25 < (x + tooltip.offsetWidth)) { x = window.innerWidth - tooltip.offsetWidth - 40; }
            if (window.innerHeight - 25 < (y + tooltip.offsetHeight)) { y = e.clientY - tooltip.offsetHeight }
            tooltip.style.top = y + 'px';
            tooltip.style.left = x + 'px';
        }
    }

    hideToolTip = (e) => {
        var tooltip = e.target.parentElement.getElementsByClassName('flowchart-tooltip')[0];
        if (tooltip) {
            tooltip.style.display = 'none';
        }
    }

    correctHeights = () => {
        var base = document.getElementById('timelineTable');
        var outerHeight = base.offsetHeight;
        var bodyContent = document.getElementById('timeline-body');
        var headHeight = outerHeight - bodyContent.offsetHeight;

        var newContentHeight = document.getElementById('bottomWindowContent').offsetHeight - headHeight - 25;
        bodyContent.style.height = newContentHeight + 'px';
        document.getElementById('verticalLine').style.height = newContentHeight + 10 + 'px';
        this.correctHistogram();
    }

    correctHistogram = () => {
        var bodyContent = document.getElementById('timeline-body');
        var scrollBarActive = bodyContent.scrollHeight > bodyContent.offsetHeight;
        if (scrollBarActive)
            document.getElementById('timelineContent').style.width = bodyContent.firstChild.childNodes[2].offsetWidth + 'px';
        else
            document.getElementById('timelineContent').style.width = '100%';
        this.recalcTimelineLabels(bodyContent);
    }

    recalcTimelineLabels = (bodyContent) => {
        bodyContent.getElementsByTagName('tr').forEach(function (tr) {
            var td = tr.lastChild;
            var div = td.firstChild;
            var shortcut = div.firstChild;

            if (shortcut.offsetWidth + div.offsetLeft >= (td.offsetWidth)) {
                shortcut.style.position = 'relative';
                shortcut.style.left = div.offsetWidth - shortcut.offsetWidth - 10 + 'px';
            } else {
                shortcut.style.position = '';
                shortcut.style.left = '';
            }
        });
    }

    sliderChange = (value) => {
        this.setState({
            sliderVal: value[0]
        });
        this.moveTimeline(value[0]);
    }

    enableTimeline = (enable) => {
        var line = document.getElementById('verticalLine');

        if (!enable) {
            line.style.display = 'none';
        }
        else {
            line.style.display = 'block';
            this.moveTimeline(this.state.sliderVal);
        }
        this.props.applyFloatingFilter(enable, this.state.sliderVal);

        this.setState({
            timelineEnabled: enable
        });
    }

    moveTimeline = (val) => {
        if (this.props.bottomWindow.timeline.data) {
            var line = document.getElementById('verticalLine');
            var r;
            if (this.props.bottomWindow.timeline.data.maxYear == val)
                r = 1;
            else
                r = ((val - this.props.bottomWindow.timeline.data.minYear) / (this.props.bottomWindow.timeline.data.maxYear - this.props.bottomWindow.timeline.data.minYear));

            if (document.getElementById('timeline-body').firstChild && document.getElementById('timeline-body').firstChild.childNodes[2]) {
                var td = document.getElementById('timeline-body').firstChild.childNodes[2];
                line.style.left = td.offsetLeft + 35 + (td.offsetWidth - 32) * r + 'px';
            }
            this.props.applyFloatingFilter(this.state.timelineEnabled, val);
        }
    }

    renderFilterInput = () => {
        const input = {
            value: {
                [F_ACTIVITY.active]: 1,
                [F_ACTIVITY.inactive]: 2
            },
            checked: {
                [F_ACTIVITY.active]: this.state.timelineEnabled,
                [F_ACTIVITY.inactive]: !this.state.timelineEnabled
            },
            label: {
                [F_ACTIVITY.active]: 'Charts.FilterOn',
                [F_ACTIVITY.inactive]: 'Charts.FilterOff'
            },
        };

        return (
            <div className="columns">
                <div className="column is-4 bb-input-label-column">
                    <div style={{ display: "flex", alignItems: "center", "height": "100%" }}>
                        {this.props.translate("Charts.Filter")}
                    </div>
                </div>
                <div className="column is-8">
                    <div className="settings-item">
                        <div className="settings-row">
                            <div className="settings-selector">
                                {
                                    Object.keys(input.value).map(j => (
                                        <React.Fragment key={j}>
                                            <span data-active={input.checked[j]}
                                                onClick={() => this.enableTimeline(j === F_ACTIVITY.active)}
                                            >
                                                {input.label ? this.props.translate(input.label[j]) : ""}
                                            </span>
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(chartActions, dispatch)
)(ChartTimeline)));


